import { NgModule } from '@angular/core';
import { CalendarPageComponent } from './calendar-page.component';
import { CalendarSlugConfirmationDialogComponent } from './calendar-slug-card/calendar-slug-confirmation-dialog/calendar-slug-confirmation-dialog.component';
import { CalendarSlugCardComponent } from './calendar-slug-card/calendar-slug-card.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';

@NgModule({
  declarations: [CalendarPageComponent, CalendarSlugCardComponent, CalendarSlugConfirmationDialogComponent],
  providers: [],
  exports: [CalendarPageComponent, CalendarSlugCardComponent, CalendarSlugConfirmationDialogComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatCardModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatProgressSpinnerModule,
    ReactiveFormsModule,
    TranslateModule,
    GalaxyAlertModule,
    GalaxyFormFieldModule,
  ],
})
export class CalendarModule {}
